import axios from 'axios'
import {Toast } from 'vant'
import store from '@/store'
// import { getToken } from './utils/auth
import setting from './setting'
let loadingInstance = null
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASEURL,
  baseURL: setting.baseUrl,
  timeout: 500000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    loadingInstance = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中',
    });
    
    if (store.state.token || store.state.userId) {
      config.headers['token'] = encodeURIComponent(store.state.token || '')
      config.headers['user_id'] = encodeURIComponent(store.state.userId || '')
    }
    config.headers['Content-Type']= config.contentType ? config.contentType : "application/json"
    return config
  },
  error => {
    Toast.clear();
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data?response.data:response
    Toast.clear();
    if (res.code !== 0) {
      Toast.fail(res.msg || 'Error');
      if (res.code == 602) {
        // store.com
        store.commit('token', '')
        localStorage.clear()
        // location.reload();
      }
       if (res.msg ===  '验证码无效') {
        return res.msg
      }
        if (res.msg === '学生还没有报名') {
        return res.msg
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res.data
    }
  },
  error => {
    Toast.clear();
    Toast.fail(error.message);
    return Promise.reject(error)
  }
)

export default service
